<template>
    <!-- Histórico de diseños -->
    <b-row>

        <b-col md="2" sm="12"></b-col>

        <b-col md="3" sm="12">
            <div class="align-items-center d-flex justify-content-center w-100">
                <img :style="{ width: '70%' }" src="img/designer_ets.png" alt="Diseñador">
            </div>
            <b-alert show variant="none" class="p-2">
                <strong>🎨 Diseños listos para usar</strong>
                <p class="m-0">Aquí encontrarás un listado de diseños preconfigurados que puedes editar según tus
                    necesidades.</p>
                <p class="m-0">¿Quieres algo totalmente nuevo? También puedes crear tus propios diseños desde cero.
                </p>
            </b-alert>
            <b-button block class="mt-3" variant="info" @click="onHandleNewDesign">+ Nuevo diseño 🎨</b-button>
        </b-col>

        <b-col md="4" sm="12">

            <!-- Generales -->
            <b-alert class="align-items-center d-flex justify-content-between px-2 m-0" show variant="light">
                <strong><i class="fa fa-table mx-2 mt-2"></i>GENERALES</strong>
                <b-badge variant="primary" class="mr-2">{{ getGeneralDesignsLength }}</b-badge>
            </b-alert>
            <b-list-group class="shadow-sm">
                <HistoryItem v-for="design of generalDesigns" :key="design.id" :design="design" />
            </b-list-group>

            <br />

            <!-- Por empresa -->
            <div>
                <b-alert class="mt-2 px-2 m-0" show variant="light">                        
                    <div class="align-items-center d-flex justify-content-between">
                        <strong><i class="fa fa-building mx-2 mt-2"></i>EMPRESARIALES</strong>
                        <b-badge variant="primary" class="mr-2">{{ getByCompanyDesignsQuantity }}</b-badge>
                    </div>
                
                    <!-- Seleccionar empresa -->                    
                    <b-form-group class="mx-2">
                        <label for="width">Seleccionar empresa </label>
                        <el-select v-model="filterHistory.company_id" filterable remote clearable
                            no-data-text="No hay datos que coincidan" no-match-text="No hay datos que coincidan"
                            :remote-method="onHandleSearchCompany" :loading="globalLoading">
                            <el-option v-for="company in companies" :key="company.id" :label="company.nombre"
                                :value="company.id">
                            </el-option>
                        </el-select>
                    </b-form-group>
                </b-alert>

                <b-list-group class="shadow-sm">
                    <HistoryItem v-for="design of getCompaniesDesigns" :key="design.id" :design="design" :companyId="filterHistory.company_id" type="BY_COMPANY" />
                    <b-alert v-if="getByCompanyDesignsQuantity === 0 && filterHistory.company_id" show variant="light" class="m-0">
                        <strong>No hay diseños para esta empresa</strong>
                        <p class="m-0">
                            Puedes crear un nuevo diseño 🎨 haciendo click
                            <b-link @click="onHandleNewDesign">aquí</b-link>
                        </p>                        
                    </b-alert>
                </b-list-group>             
            </div>            

        </b-col>

        <!-- Modal de duplicación de diseño -->
        <ModalDuplicateDesign />

    </b-row>
</template>

<script>

import { mapState, mapMutations, mapActions } from 'vuex';

// Componentes
import HistoryItem from './fragments/HistoryItem.vue'
import ModalDuplicateDesign from './fragments/ModalDuplicateDesign.vue';

export default {

    data() {
        return {
            company_id: null
        }
    },

    components: {
        HistoryItem,
        ModalDuplicateDesign
    },

    computed: {

        ...mapState('labelDesigner', [
            'filterHistory',
            'generalDesigns',
            'activeTab',
            'selectedLayout'
        ]),

        ...mapState("Reporteinventario", {
            companies: 'listaEmpresas'
        }),

        ...mapState("dashboard", {
            globalLoading: 'cargando_datos_select'
        }),

        getCompaniesDesigns() {
            try {
                return this.filterHistory.designs
            } catch (e) {
                return []
            }
        },

        getByCompanyDesignsQuantity() {
            try {
                return this.getCompaniesDesigns.length
            } catch (e) {
                return 0
            }
        },

        getGeneralDesignsLength() {
            try {
                return this.generalDesigns.length
            } catch (e) {
                return 0
            }
        },

    },

    watch: {

        activeTab(next, prev) {
            if (next && next !== prev && next === 1) {
                this.resetSelectedLayout()
                this.setActiveSection(null)
            }
        },

        'filterHistory.company_id'(next, prev) {
            if (next && next !== prev) {
                this.getLabelDesigns({ type: 'BY_COMPANY', company_id: next });
            }
            else this.setByCompanyDesigns([])
        }

    },

    methods: {

        ...mapMutations('labelDesigner', [
            'resetSelectedLayout',
            'setActiveSection',
            'setSelectedLayout',
            'setActiveTab',
            'setByCompanyDesigns'
        ]),

        ...mapActions('labelDesigner', {
            changeStateLabelDesign: 'changeState',
            getLabelDesigns: 'getLabelDesigns',
        }),

        ...mapActions("Reporteinventario", {
            getCompanies: 'getEmpresas'
        }),

        onHandleNewDesign() {
            this.resetSelectedLayout()
            this.setActiveSection(null)
            this.setActiveTab(2)
        },

        async onHandleSearchCompany(nameCompany) {
            if (!(nameCompany.length >= 1)) return

            await this.getCompanies({ nombre: nameCompany });
        }

    }

}
</script>

<style scoped></style>
